import styled from 'styled-components';

import GenericSpinner from 'root/activities/components/GenericSpinner';

import { ActionButton, CloseButton } from '../../sharedStyledComponents/Components';
import ButtonGoActive from '../../buttons/ButtonGoActive';

export const BackgroundContainer = styled.div`
  position: absolute;
  width: 673;
  height: 430;
  top: 62;
  left: 176;
`;

export const Background = styled(BackgroundContainer)`
  top: 112;
  left: 176;
`;

export const Burst = styled.div`
  position: absolute;
  width: 240;
  height: 240;
  top: 165;
  left: 230;
`;

export const OliviaIcon = styled.div`
  position: absolute;
  top: 180;
  left: 240;
  width: 202;
  height: 210;
`;

export const TitleTextContainer = styled.div`
  position: absolute;
  width: 129;
  height: 34;
  top: 132;
  left: 450;
`;

export const TitleText = styled.h2`
  margin: 0;
  text-align: center;
  font-size: 27;
  font-family: Quicksand;
  color: #ffffff;
`;

export const DescriptionTextContainer = styled.div`
  position: absolute;
  width: 302;
  height: 32;
  top: 210;
  left: 485;
`;

export const DescriptionText = styled.h3`
  margin: 0;
  text-align: left;
  font-size: 27;
  font-family: Quicksand;
  color: #ffffff;
`;

export const QuestionTextContainer = styled.div`
  position: absolute;
  width: 290;
  height: 80;
  top: 255;
  left: 485;
`;

export const QuestionText = styled.p`
  margin: 0;
  padding: 0;
  text-align: left;
  font-size: 17;
  font-family: Open Sans;
  color: #ffffff;
  opacity: 0.7;
`;

export const IconContainer = styled.div`
  position: absolute;
  width: 79;
  height: 82;
  top: 121;
  left: 246;
`;

export const TitleContainer = styled.div`
  position: absolute;
  width: 160;
  height: 34;
  top: 82;
  left: 435;
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 27;
  font-family: Quicksand Medium;
  color: #ffffff;
  margin: 0;
`;

export const DescriptionContainer = styled.div`
  position: absolute;
  width: 445;
  height: 55;
  top: 145;
  left: 337;
`;

export const Description = styled.p`
  text-align: left;
  font-size: 18;
  font-family: Quicksand;
  color: #ffffff;
  margin: 0;
`;

export const CloseModalButton = styled(CloseButton)`
  z-index: 1;
  position: absolute;
  top: 75;
  left: 815;
`;

export const GamesContainer = styled.div`
  display: flex;
  z-index: 1;
  margin-top: 75px;
  width: 540px;
  justify-content: center;
`;

export const StyledIconWrapper = styled.div`
  width: calc(100% / 3);
  height: 216px;
`;

export const GoButton = styled(ButtonGoActive)`
  position: absolute;
  top: 443;
  left: 387;
`;

export const ContinueButton = styled(ActionButton)`
  position: absolute;
  left: 387;
  top: 393;
`;

export const Spinner = styled(GenericSpinner)`
  z-index: 22;
  position: absolute;
  top: 0;
`;
